const breakpoints = {
  window: {
    sm: '1px',
    md: '1024px',
    lg: '1366px',
    xl: '1366px',
    xxl: '1920px',
  },
  container: {
    sm: '100%',
    md: '880px',
    lg: '1272px',
    xl: '1272px',
  },
};

module.exports = breakpoints;
